import styled from 'styled-components'

import colors from 'styles/colors'

interface LastItemInfoProps {
    text: string
}

export const LastItemInfo = ({ text }: LastItemInfoProps) => {
    return <Text>{text}</Text>
}

const Text = styled.span`
    color: ${colors.white};
    background: rgba(255, 255, 255, 0.2);
    border-radius: 2rem;
    padding: 0.8rem 1rem;
    font-weight: 600;
    font-size: 1.2rem;
`
